import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App.jsx";
// Branding is resolved from the hostname before anything renders, so a
// partner-hosted deployment never paints our brand first. See src/lib/branding/
// — a generated copy of shared/branding/.
import { BrandingProvider } from "@/lib/branding";

const API_URL = import.meta.env.VITE_STN_API_URL || "http://localhost:4000";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrandingProvider apiBase={API_URL}>
      <App />
    </BrandingProvider>
  </React.StrictMode>,
);
